import React from 'react';
import './FileDownloader.less';

interface FileDownloaderProps {
  onClick: () => void
}

export function FileDownloader({onClick}: FileDownloaderProps) {
  return (
    <div className="dpc-file-downloader" onClick={onClick}>
      <button className="dpc-file-downloader__square">
        <div className="dpc-file-downloader__icon"></div>
        <span className="dpc-file-downloader__text">Click Here To Download</span>
      </button>
    </div>
  );
}
